export default __webpack_public_path__ + "resources/icons/d322-3b04.webp";